<template>
  <VView class="menu">
    <VBlock class="menu__crown" max-width="106px">
      <img src="@/assets/crown.png" />
    </VBlock>

    <hr />
    <!-- <VText center big>zmierz się w naszej grze<br />i wygraj jedną z super nagród!</VText> -->
    <VText center big>zmierz się w naszej grze!</VText>
    <hr />

    <VBlock class="menu__artwork" max-width="336px">
      <img src="@/assets/menu-artwork.png" />
    </VBlock>


    <VBlock max-width="500px">
      <transition :name="getButtonTransitionName(item, index)"
        v-for="(item, index) in items" :key="index"
        appear
      >
        <VButton :to="item.to" :href="item.href" :alternative="!isLastButton(index)">{{ item.label }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Menu',

  data() {
    return {
      items: [
        { to: '/about', label: 'O Pufku' },
        { to: '/contest', label: 'Zagraj' },
        { to: '/top', label: 'TOP 200' },
      ],
    };
  },

  methods: {
    getButtonTransitionName(item, index) {
      return index % 2 === 0
        ? 'bounceLeft'
        : 'bounceRight';
    },

    isLastButton(index) {
      return index === this.items.length - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  &__crown {
    margin-bottom: -30px !important;
  }

  hr {
    border: none;
    height: 5px;
    width: 100%;
    background-color: #1a1109;
    max-width: 545px;
  }

  &__artwork {
    margin-bottom: calc($gridGutter * -2) !important;
  }
}
</style>
